import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "relative cursor-move",
  id: "feedback-carousel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_feedback_section_carousel_slide = _resolveComponent("the-feedback-section-carousel-slide")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      pagination: {
        dynamicBullets: true,
        clickable: true,
      },
      speed: 3000,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      }
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviews, (review) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: review.text
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_feedback_section_carousel_slide, {
                name: review.client_name,
                type: review.client_type
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(review.text), 1)
                ]),
                _: 2
              }, 1032, ["name", "type"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}